<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<p class="sp1"> </p>
<hgroup>
<h1 class="FMH"><a id="PageBreak-vii">CONTENTS</a></h1><a id="PageBreak-vii">
</a></hgroup><a id="PageBreak-vii">
</a><ol class="toc"><a id="PageBreak-vii">
</a><li class="CFMH" id="c_intro"><a id="PageBreak-vii"></a><a href="#/xhtml/introduction#intro">Introduction: The Jewish-Muslim Question in Modern France</a></li>
<li class="CCT" id="c_ch1"><a href="#/xhtml/chapter_1#ch1"><span class="ccn">1.</span> Jewish, Muslim, and Possibly French</a></li>
<li class="CCT" id="c_ch2"><span href="#/xhtml/chapter_2#ch2" title="Link target outside of Sample"><span class="ccn">2.</span> Pushing the Boundaries of Mediterranean France</span></li>
<li class="CCT" id="c_ch3"><span href="#/xhtml/chapter_3#ch3" title="Link target outside of Sample"><span class="ccn">3.</span> Jews as Muslims and Muslims as Jews</span></li>
<li class="CCT" id="c_ch4"><span href="#/xhtml/chapter_4#ch4" title="Link target outside of Sample"><span class="ccn">4.</span> Expanding the Republic or Ending the Empire?</span></li>
<li class="CCT" id="c_ch5"><span href="#/xhtml/chapter_5#ch5" title="Link target outside of Sample"><span class="ccn">5.</span> A Time of Choosing</span></li>
<li class="CCT" id="c_ch6"><span href="#/xhtml/chapter_6#ch6" title="Link target outside of Sample"><span class="ccn">6.</span> Higher Fences, Better Neighbors?</span></li>
<li class="CCT" id="c_ch7"><span href="#/xhtml/chapter_7#ch7" title="Link target outside of Sample"><span class="ccn">7.</span> Jews as Jews and Muslims as Muslims</span></li>
<li class="CCT-1" id="c_conclu"><span href="#/xhtml/conclusion#conclu" title="Link target outside of Sample">Conclusion: Jews and Muslims Always and Forever?</span></li>
<li class="CBMH" id="c_note"><span href="#/xhtml/note#note" title="Link target outside of Sample">Notes</span></li>
<li class="CBMH" id="c_bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Selected Bibliography</span></li>
<li class="CBMH" id="c_ack"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></li>
<li class="CBMH" id="c_index"><span href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></li>
</ol>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4bc0542a